import request from "@/utils/request";

export function queryShopTicketList(params) {
  return request({
    url: "api/system/shopTicket/queryShopTicketList",
    method: "post",
    data: params
  });
}

export function getShopTicket(params) {
  return request({
    url: "api/system/shopTicket/getShopTicket",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/invoce/index.js